import { render, staticRenderFns } from "./DocumentsList.vue?vue&type=template&id=194831f2&scoped=true"
import script from "./DocumentsList.vue?vue&type=script&lang=ts"
export * from "./DocumentsList.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsList.vue?vue&type=style&index=0&id=194831f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194831f2",
  null
  
)

export default component.exports